import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Alert } from '../models/Alert';
import { PagedList } from '../models/PagedList';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';

export interface AlertListParams {
  mcode?: string;
  ccode?: string;
  eventType?: string;
  audience?: string;
  /** Admin-tier only: when true, list unscoped role alerts. Ignored for contributors. */
  all?: boolean;
  page?: number;
  pageSize?: number;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService extends BaseService {
  private readonly apiBaseUrl = `${environment.LRNEXT_API_URL}/alerts`;

  constructor(authService: AuthService, http: HttpClient) {
    super(authService, http);
  }

  list(params: AlertListParams = {}): Observable<PagedList<Alert>> {
    let httpParams = new HttpParams()
      .set('page', String(params.page ?? 1))
      .set('pageSize', String(params.pageSize ?? 25));

    if (params.mcode) {
      httpParams = httpParams.set('mcode', params.mcode);
    }
    if (params.ccode) {
      httpParams = httpParams.set('ccode', params.ccode);
    }
    if (params.eventType) {
      httpParams = httpParams.set('eventType', params.eventType);
    }
    if (params.audience) {
      httpParams = httpParams.set('audience', params.audience);
    }
    if (params.all) {
      httpParams = httpParams.set('all', 'true');
    }

    return this.get<PagedList<Alert>>(this.apiBaseUrl, { params: httpParams });
  }
}
